/* src/app/components/sidebar/sidebar.component.scss */
:host {
  display: block;
  position: relative;
  z-index: 1;
}
:root {
  --z-content: 1;
  --z-right-panel: 1100;
  --z-sidebar-overlay: 1200;
  --z-sidebar: 1300;
  --z-modal: 2000;
  --z-toast: 3000;
}
.sidebar {
  --sidebar-width: 300px;
  --sidebar-collapsed-width: 82px;
  --primary: #253b80;
  --primary-dark: #1d2f68;
  --primary-soft: #eef2ff;
  --text-primary: #18213a;
  --text-secondary: #5f6b84;
  --text-muted: #8993a8;
  --border: #e8ecf3;
  --hover: #f5f7fb;
  position: fixed;
  top: 9px;
  left: 18px;
  bottom: 9px;
  z-index: var(--z-sidebar);
  display: flex;
  flex-direction: column;
  width: var(--sidebar-width);
  padding: 24px 14px 14px;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(225, 230, 240, 0.85);
  border-radius: 26px;
  box-shadow: 0 12px 35px rgba(36, 50, 80, 0.08);
  transition:
    width 0.25s ease,
    transform 0.28s ease,
    box-shadow 0.25s ease;
}
.sidebar-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-sidebar-overlay);
  background: rgba(15, 23, 42, 0.36);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.25s ease, visibility 0.25s ease;
}
.sidebar-overlay.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}
.sidebar.collapsed {
  width: var(--sidebar-collapsed-width);
}
.sidebar.collapsed .sidebar-brand,
.sidebar.collapsed .sidebar-item,
.sidebar.collapsed .collapse-button,
.sidebar.collapsed .sidebar-user {
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}
.sidebar.collapsed .brand-content,
.sidebar.collapsed .sidebar-label,
.sidebar.collapsed .user-information,
.sidebar.collapsed .logout-button {
  display: none;
}
.sidebar.collapsed .collapse-button span:not(.collapse-icon) {
  display: none;
}
.sidebar-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  min-height: 72px;
  gap: 12px;
  padding: 0 10px 20px;
  overflow: hidden;
}
.brand-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #edf0f5;
  border-radius: 14px;
  box-shadow: 0 5px 15px rgba(52, 73, 110, 0.1);
}
.brand-logo img {
  display: block;
  width: 36px;
  height: 36px;
  object-fit: contain;
}
.brand-content {
  min-width: 0;
  overflow: hidden;
}
.brand-title {
  overflow: hidden;
  color: var(--text-primary);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.brand-subtitle {
  margin-top: 4px;
  overflow: hidden;
  color: var(--text-muted);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-navigation {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  gap: 6px;
  padding: 18px 2px;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #d9deea transparent;
}
.sidebar-navigation::-webkit-scrollbar {
  width: 4px;
}
.sidebar-navigation::-webkit-scrollbar-track {
  background: transparent;
}
.sidebar-navigation::-webkit-scrollbar-thumb {
  background: #d9deea;
  border-radius: 10px;
}
.sidebar-item {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 50px;
  gap: 13px;
  padding: 7px 12px;
  color: var(--text-secondary);
  background: transparent;
  border: 0;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.4;
  text-decoration: none;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    transform 0.2s ease;
}
.sidebar-item:hover {
  color: var(--primary);
  background: var(--hover);
  transform: translateX(2px);
}
.sidebar-item:hover .sidebar-icon {
  color: var(--primary);
  background: #eef1f8;
}
.sidebar-item:active {
  transform: scale(0.98);
}
.sidebar-item.active {
  color: var(--primary);
  background: var(--primary-soft);
  font-weight: 600;
  transform: none;
}
.sidebar-item.active::before {
  position: absolute;
  top: 8px;
  bottom: 8px;
  left: 0;
  width: 4px;
  background: var(--primary);
  border-radius: 0 5px 5px 0;
  content: "";
}
.sidebar-item.active .sidebar-icon {
  color: var(--primary-soft);
  background: var(--primary);
  box-shadow: 0 2px 6px rgba(37, 59, 128, 0.08);
}
.sidebar-item.active .sidebar-label {
  color: var(--primary);
  font-weight: 650;
}
.sidebar-item.active img {
  filter: brightness(0) invert(1);
}
.sidebar-item:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.15);
  outline-offset: 2px;
}
.sidebar-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #69758d;
  background: #f7f8fb;
  border-radius: 11px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    box-shadow 0.2s ease;
}
.sidebar-icon i {
  color: inherit;
  font-size: 19px;
  line-height: 1;
}
.sidebar-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: inherit;
  font-size: 15px;
  font-weight: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-bottom {
  position: relative;
  flex-shrink: 0;
  padding-top: 1px;
}
.sidebar-bottom::before {
  display: block;
  height: 1px;
  margin: 0 6px 12px;
  background: var(--border);
  content: "";
}
.collapse-button {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  gap: 11px;
  margin: 0 0 10px;
  padding: 5px 8px;
  color: var(--text-secondary);
  background: transparent;
  border: 1px solid transparent;
  border-radius: 13px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-align: left;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.collapse-button:hover {
  color: var(--primary);
  background: var(--hover);
  border-color: #edf0f6;
}
.collapse-button:hover .collapse-icon {
  color: var(--primary);
  background: #eef2ff;
  border-color: #dfe5fa;
}
.collapse-button:active {
  transform: scale(0.98);
}
.collapse-button:focus-visible {
  outline: 3px solid rgba(37, 59, 128, 0.14);
  outline-offset: 2px;
}
.collapse-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  color: #69758d;
  background: #f7f8fb;
  border: 1px solid #edf0f5;
  border-radius: 10px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}
.collapse-icon i {
  font-size: 15px;
  line-height: 1;
}
.collapse-label {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  color: inherit;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sidebar-user {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 66px;
  gap: 10px;
  padding: 9px;
  box-shadow: 0 2px 8px rgba(36, 50, 80, 0.03);
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}
.sidebar-user:hover {
  background: #f5f7fb;
  border-color: #dde3ee;
  box-shadow: 0 5px 14px rgba(36, 50, 80, 0.06);
}
.user-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  overflow: hidden;
  color: #fff;
  background: #253b80;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
}
.user-avatar .user-avatar-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
.user-avatar .user-avatar-letter {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.user-information {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  gap: 3px;
  overflow: hidden;
}
.user-name {
  overflow: hidden;
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.user-email {
  overflow: hidden;
  color: var(--text-muted);
  font-size: 11.5px;
  font-weight: 500;
  line-height: 1.3;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.logout-button,
.collapsed-logout-button {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #718096;
  background: transparent;
  border: 1px solid transparent;
  cursor: pointer;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    transform 0.15s ease;
}
.logout-button:hover,
.collapsed-logout-button:hover {
  color: #dc2626;
  background: #fef2f2;
  border-color: #fee2e2;
}
.logout-button:focus-visible,
.collapsed-logout-button:focus-visible {
  outline: 3px solid rgba(220, 38, 38, 0.12);
  outline-offset: 2px;
}
.logout-button i,
.collapsed-logout-button i {
  font-size: 18px;
  line-height: 1;
}
.logout-button {
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 10px;
}
.logout-button:active {
  transform: scale(0.94);
}
.collapsed-logout-button {
  width: 100%;
  height: 42px;
  margin-top: 8px;
  border-radius: 11px;
  transition:
    color 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease;
}
.right-side-panel {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: var(--z-right-panel);
  width: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  background: #fff;
  border-left: 1px solid #e5e7eb;
  box-shadow: -12px 0 35px rgba(15, 23, 42, 0.14);
  transform: translateX(100%);
  transition: transform 0.3s ease;
}
.right-side-panel.open {
  transform: translateX(0);
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .sidebar {
    --sidebar-width: 270px;
    width: var(--sidebar-width);
    left: 14px;
    padding-right: 12px;
    padding-left: 12px;
    border-radius: 22px;
  }
  .sidebar-item {
    gap: 11px;
    font-size: 14px;
  }
  .sidebar-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .sidebar-icon i {
    font-size: 18px;
  }
  .right-side-panel {
    width: min(420px, 45vw);
  }
}
@media (max-width: 991.98px) {
  .sidebar {
    top: 0;
    left: 0;
    bottom: 0;
    width: min(320px, 88vw);
    max-width: 320px;
    padding: 20px 14px 14px;
    border-radius: 0 24px 24px 0;
    box-shadow: 15px 0 40px rgba(25, 40, 70, 0.16);
    transform: translateX(-105%);
    transition: transform 0.28s ease;
  }
  .sidebar.mobile-open {
    transform: translateX(0);
  }
  .sidebar.collapsed {
    width: min(320px, 88vw);
  }
  .sidebar.collapsed .sidebar-brand,
  .sidebar.collapsed .sidebar-item,
  .sidebar.collapsed .collapse-button,
  .sidebar.collapsed .sidebar-user {
    justify-content: flex-start;
  }
  .sidebar.collapsed .sidebar-brand {
    padding-right: 8px;
    padding-left: 8px;
  }
  .sidebar.collapsed .brand-content,
  .sidebar.collapsed .sidebar-label,
  .sidebar.collapsed .user-information,
  .sidebar.collapsed .logout-button {
    display: block;
  }
  .sidebar.collapsed .sidebar-item {
    padding-right: 10px;
    padding-left: 10px;
  }
  .sidebar.collapsed .collapse-button {
    padding-right: 8px;
    padding-left: 8px;
  }
  .sidebar.collapsed .collapse-button span:not(.collapse-icon) {
    display: inline;
  }
  .sidebar.collapsed .sidebar-user {
    padding-right: 8px;
    padding-left: 8px;
  }
  .sidebar.collapsed .user-information {
    display: flex;
  }
  .sidebar.collapsed .logout-button {
    display: flex;
  }
  .sidebar-brand {
    min-height: 68px;
    padding-bottom: 16px;
  }
  .brand-logo {
    width: 44px;
    height: 44px;
    flex-basis: 44px;
  }
  .brand-logo img {
    width: 34px;
    height: 34px;
  }
  .brand-title {
    font-size: 16px;
  }
  .brand-subtitle {
    font-size: 12px;
  }
  .sidebar-navigation {
    gap: 5px;
    padding-top: 14px;
    padding-bottom: 14px;
  }
  .sidebar-item {
    min-height: 52px;
    gap: 12px;
    padding: 7px 10px;
    border-radius: 12px;
    font-size: 15px;
  }
  .sidebar-item:hover {
    transform: none;
  }
  .sidebar-icon {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 11px;
  }
  .sidebar-icon i {
    font-size: 18px;
  }
  .sidebar-label {
    font-size: 14px;
  }
  .sidebar-user {
    min-height: 66px;
    padding: 9px;
    border-radius: 14px;
  }
  .user-avatar {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
    font-size: 16px;
  }
  .user-name {
    font-size: 14px;
  }
  .user-email {
    font-size: 12px;
  }
  .right-side-panel {
    width: min(440px, 92vw);
    max-width: 440px;
  }
}
@media (max-width: 575.98px) {
  .sidebar {
    width: min(310px, 90vw);
    padding: 18px 12px 12px;
    border-radius: 0 20px 20px 0;
  }
  .sidebar.collapsed {
    width: min(310px, 90vw);
  }
  .sidebar-brand {
    padding-right: 6px;
    padding-left: 6px;
  }
  .brand-logo {
    width: 42px;
    height: 42px;
    flex-basis: 42px;
    border-radius: 12px;
  }
  .brand-logo img {
    width: 32px;
    height: 32px;
  }
  .brand-title {
    font-size: 15px;
  }
  .brand-subtitle {
    margin-top: 3px;
    font-size: 11px;
  }
  .sidebar-navigation {
    padding: 12px 1px;
  }
  .sidebar-item {
    min-height: 50px;
    gap: 10px;
    padding: 6px 8px;
    font-size: 14px;
  }
  .sidebar-icon {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
  }
  .sidebar-icon i {
    font-size: 17px;
  }
  .sidebar-label {
    font-size: 14px;
  }
  .collapse-button {
    min-height: 44px;
    gap: 10px;
    font-size: 13px;
  }
  .collapse-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .sidebar-user {
    min-height: 62px;
    gap: 8px;
    padding: 7px;
  }
  .user-avatar {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    font-size: 15px;
  }
  .user-name {
    font-size: 13px;
  }
  .user-email {
    font-size: 11px;
  }
  .logout-button {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }
  .logout-button i {
    font-size: 17px;
  }
  .right-side-panel {
    width: 100%;
    max-width: 100%;
    border-left: 0;
    box-shadow: -8px 0 28px rgba(15, 23, 42, 0.14);
  }
}
@media (max-width: 380px) {
  .sidebar {
    width: 88vw;
  }
  .sidebar-item {
    min-height: 48px;
  }
  .sidebar-icon {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
  }
  .sidebar-label {
    font-size: 13px;
  }
  .brand-title {
    font-size: 14px;
  }
  .brand-subtitle {
    font-size: 10px;
  }
}
.mobile-close-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  padding: 0;
  color: #344054;
  background: #fff;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.mobile-close-button:hover {
  color: #253b80;
  background: #f8f9fc;
  border-color: #d0d5dd;
  box-shadow: 0 3px 10px rgba(16, 24, 40, 0.08);
}
.mobile-close-button:active {
  transform: scale(0.95);
}
.mobile-close-button:focus-visible {
  outline: none;
  border-color: #635bff;
  box-shadow: 0 0 0 3px rgba(99, 91, 255, 0.14);
}
.mobile-close-button i {
  line-height: 1;
}
@media (max-width: 768px) {
  .mobile-close-button {
    width: 40px;
    height: 40px;
    flex-basis: 40px;
    border-radius: 9px;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .mobile-close-button {
    width: 38px;
    height: 38px;
    flex-basis: 38px;
    border-radius: 8px;
    font-size: 14px;
  }
}
@media (max-width: 360px) {
  .mobile-close-button {
    width: 36px;
    height: 36px;
    flex-basis: 36px;
    font-size: 13px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .sidebar,
  .sidebar-item,
  .sidebar-icon,
  .collapse-button,
  .sidebar-user,
  .logout-button,
  .sidebar-overlay,
  .right-side-panel,
  .mobile-close-button {
    transition: none !important;
  }
}
/*# sourceMappingURL=sidebar.component.css.map */
